<template>
  <div>
    <!-- <Loading v-if="loading"></Loading> -->
    <Layout>
      <div class="pt-4">
        <h3 style="font-weight: bold">Today’s Top Performing Agents</h3>
      </div>
      <section class="pt-5">
        <div>
          <b-tabs active-nav-item-class="top-agent-active" content-class="mt-3">
            <b-tab class="pl-0" title="Pinpad Transactions">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topPinpadEntries"
                ></b-form-select>
                <span slot="entries-no"
                  >of {{ topPinpadEntries.length }} entries</span
                >
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :items="topPinpadData"
                ></b-table>
              </TopAgentsTable>
            </b-tab>
            <b-tab title="POS Transactions">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topPosEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :items="topPosData"
                ></b-table>
              </TopAgentsTable>
            </b-tab>
            <b-tab title="Transfer">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topTransferEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :items="topTransferData"
                ></b-table>
              </TopAgentsTable>
            </b-tab>
            <b-tab title="Account Opening">
              <TopAgentsTable>
                <b-form-select
                  class="show-select"
                  slot="select-entry"
                  value="1"
                  :options="topAccountEntries"
                ></b-form-select>
                <b-table
                  slot="table"
                  sticky-header
                  hover
                  :items="topAccountData"
                ></b-table>
              </TopAgentsTable>
            </b-tab>
          </b-tabs>
        </div>
      </section>
    </Layout>
  </div>
</template>

<script>
// import Loading from "@/components/Loading.vue";
import Layout from "@/components/Layout.vue";
import TopAgentsTable from "@/components/TopAgentsTable.vue";
import { mapState } from "vuex";
export default {
  name: "TopAgents",
  components: {
    // Loading,
    Layout,
    TopAgentsTable,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: (state) => state.topAgents.initialLoad,
      delay: (state) => state.user.delay,
      options: (state) => state.user.options,

      topPinpadData: (state) => {
        if (state.topAgents.topPinpad.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPinpad.data;
        }
      },
      topPinpadEntries: (state) => {
        if (state.topAgents.topPinpad.data > 0) {
          return [...state.topAgents.topPinpad.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topPosData: (state) => {
        if (state.topAgents.topPos.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topPos.data;
        }
      },
      topPosEntries: (state) => {
        if (state.topAgents.topPos.data > 0) {
          return [...state.topAgents.topPos.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topTransferData: (state) => {
        if (state.topAgents.topTransfer.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topTransfer.data;
        }
      },
      topTransferEntries: (state) => {
        if (state.topAgents.topTransfer.data > 0) {
          return [...state.topAgents.topTransfer.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
      topAccountData: (state) => {
        if (state.topAgents.topAccount.data.length === 0) {
          return [
            {
              No_data: "No data to be displayed",
            },
          ];
        } else {
          return state.topAgents.topAccount.data;
        }
      },
      topAccountEntries: (state) => {
        if (state.topAgents.topAccount.data > 0) {
          return [...state.topAgents.topAccount.data.keys()];
        } else {
          return [...Array(0).keys()];
        }
      },
    }),
  },
  methods: {},
};
</script>

<style></style>
